<template>
  <div>
    <v-dialog
      scrollable
      v-model="cloneInitiativeDialog"
      width="650px"
      @keydown.esc="close"
      persistent
      scroll-strategy="block">
      <v-card>
        <v-card-title class="headline" primary-title>
          <span>Clonar Iniciativa - {{ initiative.key }}</span>
        </v-card-title>

        <v-divider class="ma-0"></v-divider>

        <v-card-text class="initiativeDialog">
          <!-- Overlay de Loading -->
          <div v-if="loadingClone" class="clone-overlay">
            <div class="clone-loading">
              <v-progress-circular indeterminate size="64" color="primary" />
              <div class="mt-3 font-weight-bold">Processando clonagem...</div>
            </div>
          </div>

          <!-- Resultados da clonagem -->
          <div v-if="showResults && cloneResponse" class="clone-results">
            <v-layout row wrap >

              <!-- sucessos -->
              <v-flex xs12>
                <div class="px-3 pb-4">
                  <v-layout row>
                    <v-icon color="green" class="mr-2">mdi-check-circle</v-icon>
                    <strong>
                      {{ resultsSuccessCount() }} clonage{{
                        resultsSuccessCount() > 1 ? "ns" : "m"
                      }}
                      concluída{{ resultsSuccessCount() > 1 ? "s" : "" }} com
                      sucesso.
                    </strong>
                  </v-layout>
                  <div class="chips-container mt-2 px-3">
                    <v-chip
                      v-for="r in resultsByStatus('success')"
                      :key="r.phone_number + '-success'"
                      color="green"
                      text-color="white"
                      small
                      class="ma-1"
                    >
                      <v-icon left small class="mr-1">mdi-whatsapp</v-icon>
                      {{ r.phone_number | phoneNumber }}
                    </v-chip>
                  </div>
                </div>
              </v-flex>

              <!-- falhas -->
              <v-flex xs12>
                <v-divider class="ma-0"></v-divider>
                <div class="px-3 py-4">
                  <v-layout row>
                    <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
                    <strong>
                      {{ resultsFailureCount() }} clonage{{
                        resultsFailureCount() > 1 ? "ns" : "m"
                      }}
                      com falha{{ resultsFailureCount() > 1 ? "s" : "" }} ou
                      exceç{{ resultsFailureCount() > 1 ? "ões" : "ão" }}.
                    </strong>
                  </v-layout>

                  <div class="mt-2 exception-details">
                    <v-expansion-panel>
                      <v-expansion-panel-content
                        v-for="r in exceptionResults()"
                        :key="r.phone_number + '-detail'"
                      >
                        <div slot="header" class="exception-header">
                          <v-icon small color="error" class="mr-1">
                            mdi-alert
                          </v-icon>
                          <b class="copy-container"  @click="copyValue(r.phone_number, 'Sender')">
                            {{ r.phone_number | phoneNumber }}
                            <v-icon small class="copy-icon ml-1">mdi-content-copy</v-icon>
                          </b>
                        </div>
                        <v-divider class="mx-4 pb-2"></v-divider>
                        <div class="error-text pt-1 pb-4 px-5">
                          <div class="error-friendly">
                            <span
                              class="copy-container caption py-1 grey--text text--darken-2"
                              @click="copyValue(r.meta_waba_id, 'WABA ID')"
                            >
                              Waba Id: {{ r.meta_waba_id }}
                              <v-icon small class="copy-icon ml-1">mdi-content-copy</v-icon>
                            </span>
                            <div class="body-2 font-weight-bold error--text">
                              {{ getErrorTitle(r.error) }}
                            </div>
                            <div class="caption mt-1 mx-2">
                              {{ getErrorMessage(r.error) }}
                            </div>
                            <div
                              class="caption mt-1 mx-2 grey--text text--darken-2"
                              v-if="getErrorCode(r.error)"
                            >
                              Código: {{ getErrorCode(r.error) }}
                            </div>
                            <v-expansion-panel class="mt-2 mx-2">
                              <v-expansion-panel-content>
                                <div slot="header" class="caption">
                                  Mais detalhes (debug)
                                </div>
                                <pre>{{ getErrorTechnical(r.error) }}</pre>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </div>
                          <v-btn
                            small
                            icon
                            @click.stop="copyValue(getErrorTechnical(r.error), 'Erro')"
                            :title="'Copiar erro'"
                          >
                            <v-icon small>mdi-content-copy</v-icon>
                          </v-btn>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </div>
                </div>
                <v-divider class="ma-0"></v-divider>
              </v-flex>

              <!-- payload do template -->
              <v-flex xs12>
                <div class="px-3 pt-4">
                  <v-expansion-panel
                    v-if="cloneResponse && cloneResponse.template_payload"
                  >
                    <v-expansion-panel-content>
                      <div slot="header" class="d-flex align-center">
                        <span class="body-2 grey--text text--darken-2">
                          Payload do Template (debug)
                        </span>
                      </div>
                      <div
                        class="blue-grey darken-4 d-flex justify-end mx-3 my-2"
                      >
                        <pre class="debug-payload-pre">
                          {{
                            formatTemplatePayload(
                              cloneResponse.template_payload,
                            )
                          }}
                        </pre>
                        <v-btn
                          small
                          flat
                          icon
                          dark
                          title="Copiar JSON"
                          @click.stop="copyTemplatePayload"
                        >
                          <v-icon small>mdi-content-copy</v-icon>
                        </v-btn>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </div>
              </v-flex>
            </v-layout>

          </div>

          <!-- Formulário de clonagem -->
          <v-form ref="form" v-if="!showResults">
            <v-container fluid>
              <v-layout row wrap>
                <!-- NOME -->
                <v-flex xs12>
                  <v-text-field
                    box
                    v-model="initiative.name"
                    label="Nome*"
                    :rules="nameRules"
                    name="name"
                    required></v-text-field>
                </v-flex>

                <!-- CHAVE -->
                <v-flex xs12 md6>
                  <v-text-field
                    box
                    v-model="initiative.key"
                    label="Chave*"
                    name="key"
                    :rules="keyRules"></v-text-field>
                </v-flex>

                <!-- CATEGORIA -->
                <v-flex xs12 md6>
                  <v-select
                    box
                    :items="metaCategoryTypes"
                    item-text="name"
                    item-value="value"
                    v-model="initiative.meta_category"
                    label="Categoria*"
                    name="meta_category"
                    :rules="metaRules"></v-select>
                </v-flex>

                <!-- TIPO DE TEMPLATE -->
                <v-flex xs12 md12>
                  <v-radio-group
                    v-model="initiative.type"
                    row
                    class="mt-2">
                    <template v-slot:label>
                      <div class="mr-4"><strong>Tipo de template:</strong></div>
                    </template>
                    <v-radio
                      label="Normal"
                      value="NORMAL"
                      color="primary"></v-radio>
                    <v-radio
                      label="Flow"
                      value="FLOW"
                      color="primary"></v-radio>
                  </v-radio-group>
                </v-flex>

                <!-- SENDERS MULTISELECT -->
                <v-flex xs12 md12>
                  <SenderSelector
                    label="Selecione um ou mais Senders*"
                    multiple
                    :items="availablePhoneSenders"
                    v-model="selectedSenders"
                  ></SenderSelector>

                  <small>{{ selectedSenders.length }} sender{{ selectedSenders.length !== 1 ? 's' : '' }} selecionado{{ selectedSenders.length !== 1 ? 's' : '' }}</small>
                  <div>
                    <v-chip
                      v-for="sender in getSelectedSendersDetails"
                      :key="sender.id"
                      small
                      close
                      @input="removeSender(sender.id)"
                      class="ma-1"
                    >
                      <small>#{{ sender.id }}</small>
                      <strong class="ml-1">
                        {{ sender.phone_number | phoneNumber }}
                      </strong>
                    </v-chip>
                  </div>
                </v-flex>

                <!-- DESCRIÇÃO -->
                <v-flex xs12>
                  <v-textarea
                    box
                    auto-grow
                    v-model="initiative.description"
                    label="Descrição"
                    name="description"
                    counter="256"
                    :maxlength="256"
                    rows="1"></v-textarea>
                </v-flex>

                <!-- CABEÇALHO -->
                <h3 class="mt-2">Cabeçalho</h3>
                <v-flex xs12 md12>
                  <v-select
                    clearable
                    box
                    :items="headerTypes"
                    item-text="name"
                    item-value="value"
                    v-model="initiative.header_type"
                    label="Tipo de cabeçalho"
                    name="header_type"></v-select>
                </v-flex>
                
                <v-flex xs12 md12 @drop="dragFile" @dragover.prevent v-if="initiative.header_type">
                  <v-text-field
                    label="Solte aqui o arquivo ou selecione-o"
                    @click="onPickFile"
                    v-model="initiative.header_text"
                    prepend-icon="attach_file"
                    clearable
                    box
                    :rules="headerTextRules">
                    <template v-slot:append-outer>
                      <v-btn
                        :href="initiative.header_text"
                        class="ma-0"
                        flat
                        icon
                        target="_blank"
                        title="Visualizar"
                        v-if="initiative.header_text">
                        <v-icon>open_in_new</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="fileInput"
                    accept="image/*"
                    @change="dragFile"
                    :rules="headerTextRules" />
                </v-flex>

                <!-- CORPO -->
                <h3 class="mt-1">Corpo</h3>
                <v-flex xs12 md12>
                  <textAreaAutocomplete
                    name="message1"
                    label="Mensagem*"
                    :message="initiative.message"
                    :variables="allowedVariables"
                    @message="initiative.message = $event" />
                </v-flex>
                <v-flex xs12 md12>
                  <div v-if="(initiative.message || '').length < 65" class="min-length-warning mt-2 mb-2">
                    <v-icon small color="warning" class="mr-1">mdi-information</v-icon>
                    É necessário mínimo de 65 caracteres para clonar. Atual: {{ (initiative.message || '').length }}/65
                  </div>
                </v-flex>
                <v-switch
                  hide-details
                  class="mb-1 mt-0 pt-0"
                  label="Mostrar mais variáveis"
                  v-model="switchShow">
                </v-switch>

                <v-flex md12 class="mb-3" style="overflow: auto; border: 1px solid #cccccc">
                  <div class="var-container" :data-select="variableSelected">
                    <v-chip
                      :key="`${k}`"
                      v-for="(variable, k) in allowedVariables"
                      v-show="switchShow ? true : variable.show"
                      class="var-content"
                      :class="{ selected: variable.selected }"
                      @click="varClick(variable.name)">
                      <small>
                        <strong>{{ variable.name }}</strong>
                        <br />
                        <small style="margin-top: -2px; font-size: 10px">
                          {{ variable.label }}
                        </small>
                      </small>
                    </v-chip>
                  </div>
                </v-flex>

                <!-- FOOTER -->
                <v-flex xs12 md12>
                  <v-textarea
                    box
                    auto-grow
                    v-model="initiative.footer_text"
                    label="Texto do footer"
                    counter="60"
                    :maxlength="60"
                    name="footer_text"
                    rows="1"></v-textarea>
                </v-flex>

                <!-- BOTÕES -->
                <h3 class="mt-1">Botões</h3>
                <v-flex v-if="initiative.buttons" xs12 md12>
                  <div v-for="(button, index) in initiative.buttons" :key="index">
                    <v-select
                      box
                      clearable
                      :items="buttonsType"
                      item-text="name"
                      item-value="value"
                      v-model="button.type"
                      label="Tipo do botão"
                      name="button_type"
                      :rules="requiredRule"
                      disabled
                      ></v-select>

                    <v-flex xs12 md12 v-if="button.type == 'URL'">
                      <v-text-field
                        box
                        :maxlength="30"
                        counter="30"
                        class="mr-2"
                        label="Texto do botão*"
                        prepend-icon="open_in_new"
                        v-model="button.text"
                        :rules="linkButtonTextRules"
                        disabled
                        ></v-text-field>
                      <v-select
                        box
                        clearable
                        :items="buttonLinkType"
                        item-text="name"
                        item-value="value"
                        v-model="button.link_type"
                        label="Link a ser enviado"
                        name="button_type"
                        prepend-icon="open_in_new"
                        :rules="requiredRule"
                        disabled
                        ></v-select>
                    </v-flex>

                    <v-flex xs12 md12 v-if="button.type == 'QUICK_REPLY'">
                      <v-text-field
                        box
                        :maxlength="20"
                        counter="20"
                        class="mr-2"
                        label="Texto do botão*"
                        prepend-icon="reply"
                        v-model="button.text"
                        :rules="buttonTextRules"
                        disabled
                        ></v-text-field>
                      <v-text-field
                        box
                        :maxlength="128"
                        counter="128"
                        class="mr-2"
                        label="Parâmetros"
                        prepend-icon="reply"
                        v-model="button.parameter"
                        disabled
                        ></v-text-field>
                    </v-flex>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider class="ma-0"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div v-if="!showResults && !cloneResponse">
            <v-btn color="primary" flat dark @click="close()">
              <v-icon left dark>mdi-close</v-icon>
              Cancelar
            </v-btn>
            <v-btn color="primary" dark @click="save()">
              <v-icon left dark>mdi-content-duplicate</v-icon>
              Clonar
            </v-btn>
          </div>
          <div v-else>
            <v-btn
            color="primary"
            flat
            dark
            @click="backToForm()"
            >
            <v-icon left dark>mdi-arrow-left</v-icon>
            Voltar
          </v-btn>
          <v-btn
            color="primary"
            dark
            class="mr-2"
            @click="closeResults()"
          >
            <v-icon left dark>mdi-check</v-icon>
            Concluir
          </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import textAreaAutocomplete from "@/components/TextAreaAutocomplete";
import { mapMutations, mapGetters, mapActions } from "vuex";
import utilsVariables from "@/utils/message-variables";
import initiativesService from "@/views/initiativeManager/service";
import SenderSelector from "../../../components/senderSelector.vue";

export default {
  props: ["cloneInitiativeDialog", "creditors", "phone_senders"],

  components: { textAreaAutocomplete },

  data() {
    return {
      initiative: {},
      allowedVariables: [],
      variables_array: utilsVariables.variables,
      selectedSenders: [],
      switchShow: false,
      excludedSenderPhoneNumbers: [],
      loadingClone: false,
      showResults: false,
      cloneResponse: null,
      metaCategoryTypes: [
        { value: "MARKETING", name: "Marketing" },
        { value: "UTILITY", name: "Utilidade" },
        { value: "AUTHENTICATION", name: "Autenticação" },
      ],
      headerTypes: [
        { value: "IMAGE", name: "Imagem" },
      ],
      buttonsType: [
        { value: "FLOW", name: "WhatsApp Flows" },
        { value: "QUICK_REPLY", name: "Resposta rápida" },
        { value: "URL", name: "Link" },
      ],
      buttonLinkType: [
        { value: "link", name: "Negociação" },
        { value: "link_creditor", name: "Credor do estímulo" },
        { value: "link_unsubscribe", name: "Descadastrar" },
        { value: "link_redirect", name: "Link de redirecionamento" },
      ],
      // regras de validação
      nameRules: [(v) => !!v || "Nome em branco"],
      keyRules: [(v) => !!v || "Chave em branco"],
      metaRules: [(v) => !!v || "Categoria em branco"],
      requiredRule: [(v) => !!v || "Campo obrigatório"],
      buttonTextRules: [(v) => !!v || "Texto em branco"],
      linkButtonTextRules: [(v) => !!v || "Texto em branco"],
      headerTextRules: [(v) => !!v || "Arquivo obrigatório quando há tipo de cabeçalho"],
    };
  },

  watch: {
    "initiative.header_type"(newValue) {
      if (!newValue) {
        this.initiative.header_text = null;
        this.initiative.header_type = null;
      }
    },
    "initiative.footer_text"(newValue) {
      if (!newValue) {
        this.initiative.footer_text = null;
      }
    },
    "initiative.message"(newMessage) {
      this.updateSelectedVars();
    },
    "initiative.key"(newKey) {
      if (newKey) {
        this.fetchInitiativesByKey(newKey);
      }
    },
    cloneInitiativeDialog(newValue) {
      if (newValue) {
        this.getAllowedVariables();
        this.initiative = Object.assign({}, this.selectedInitiative);
        
        if (!this.initiative.type) {
          this.initiative.type = "NORMAL";
        }
        
        // Atualiza as variáveis selecionadas com base na mensagem da iniciativa
        this.updateSelectedVars();
        
        this.selectedSenders = [];
        // reset estado de resultados ao abrir novamente
        this.showResults = false;
        this.cloneResponse = null;
      }
    },
  },
  computed: {
    ...mapGetters("initiativeManager", {
      selectedInitiative: "selectedInitiative",
    }),
    variableSelected() {
      this.getAllowedVariables(); // atualiza allowedVariables
      const message = this.initiative.message || "";

      this.allowedVariables.forEach((v, i) => {
        // compara removendo ou mantendo o $ conforme seu padrão
        const varName = v.name.startsWith("$") ? v.name : `$${v.name}`;
        this.$set(this.allowedVariables, i, {
          ...v,
          selected: message.includes(varName),
        });
      });
    },

    selectedVars() {
      if (!this.initiative.message) return [];

      // Captura $VAR
      const regex = /\$\w+/g;
      const matches = this.initiative.message.match(regex) || [];

      // Remove duplicatas e $
      const uniqueMatches = [...new Set(matches)].map((v) => v.slice(1));

      // Apenas as que estão na lista permitida
      const allowedNames = this.allowedVariables.map((v) => v.name);
      return uniqueMatches.filter((v) => allowedNames.includes(v));
    },

    availablePhoneSenders() {
      // Obtém o(s) sender(s) original(is) da iniciativa que está sendo clonada
      const initiativeSenderIds = this.selectedInitiative
        ? Array.isArray(this.selectedInitiative.phone_sender_ids)
          ? this.selectedInitiative.phone_sender_ids
          : this.selectedInitiative.phone_sender_id
          ? [this.selectedInitiative.phone_sender_id]
          : []
        : [];
      const selectedIds = new Set(this.selectedSenders);
      const excludedNumbers = new Set(this.excludedSenderPhoneNumbers);

      const availableSenders = [];

      // para evitar o bug de clonar a mesma
      // iniciativa em dois wabas na meta,
      // conforme montamos a lista de availableSenders guardamos
      // seus wabas ids e a cada novo sender que adicionamos, 
      // verificamos se ele não tem Waba id repetido
      // assim damos preferencia para o sender q tem o menor id
      const seenWabaIds = new Set();

      // adicionando waba_id's dos senders já selecionados para
      // evitar que duplicados possam ser selecionados 
      [...(this.selectedSenders || [])].forEach((id) => {
        const sender = this.phone_senders.find((s) => s.id === id);
        if (sender) seenWabaIds.add(sender.meta_waba_id);
      });

      [...(this.phone_senders || [])]
        .sort((a, b) => a.id - b.id)
        .forEach((sender) => {
          // verificações:
          if (
            // se já foi selecionado:
            selectedIds.has(sender.id) ||
            // se já está na iniciativa:
            initiativeSenderIds.includes(sender.id) ||
            // se o número está entre os excluído:
            excludedNumbers.has(sender.phone_number) ||
            // se o WABA ID já está entre os selecionados:
            seenWabaIds.has(sender.meta_waba_id)
          ) return;

          seenWabaIds.add(sender.meta_waba_id);
          availableSenders.push(sender);
        });

      return availableSenders;
    },

    getSelectedSendersDetails() {
      return this.phone_senders.filter(s => this.selectedSenders.includes(s.id));
    },
  },
  methods: {
    ...mapMutations("initiativeManager", {
      setSelectedInitiative: "setSelectedInitiative",
      clearSelectedInitiative: "clearSelectedInitiative",
    }),
    ...mapActions("initiativeManager", {
      createInitiativeMedia: "createInitiativeMedia",
      uploadInitiativeMedia: "uploadInitiativeMedia",
    }),

    close() {
      this.clearSelectedInitiative();
      this.excludedSenderPhoneNumbers = [];
      this.$emit("update:cloneInitiativeDialog", false);
    },
    
    async fetchInitiativesByKey(key) {
      try {
        const params = {
          page: 1,
          limit: 25,
          order: '-updated_at',
          key: key
        };
        
        const response = await initiativesService.getAllInitiatives(params);
        
        const phoneNumbers = [];
        if (response.objects && Array.isArray(response.objects)) {
          response.objects.forEach(initiative => {
            if (initiative.sender && initiative.sender.phone_number) {
              phoneNumbers.push(initiative.sender.phone_number);
            }
          });
        }
        
        this.excludedSenderPhoneNumbers = phoneNumbers;

      } catch (error) {
        console.error("Erro ao buscar initiatives por key:", error);
        this.excludedSenderPhoneNumbers = [];
      }
    },
    
    async dragFile(event) {
      event.preventDefault();
      let file = null;
      if (event.dataTransfer) {
        file = event.dataTransfer.files[0];
      } else {
        file = event.target.files[0];
      }
      await this.uploadArchive(file);
    },

    onPickFile() {
      this.$refs.fileInput.click();
    },

    async uploadArchive(file) {
      const payload = {
        info: [
          {
            content_type: file.type,
            size: file.size,
            name: file.name,
            type: file.type,
          },
        ],
        type: ["whatsapp", "initiatives"],
      };

      const s3 = await this.createInitiativeMedia(payload);
      await this.uploadToS3(s3, file);
    },

    async uploadToS3(s3, fileData) {
      const data = this.createS3UploadForm(s3._storage, fileData);
      const params = {
        url: s3._storage.url,
        data,
      };

      await this.uploadInitiativeMedia(params);
      this.initiative = { ...this.initiative, header_text: s3.url };
    },

    createS3UploadForm(storage, file) {
      let formData = new FormData();
      formData.append("Content-Type", storage.fields["Content-Type"]);
      formData.append("key", storage.fields.key);
      formData.append("AWSAccessKeyId", storage.fields.AWSAccessKeyId);
      formData.append("acl", storage.fields.acl);
      formData.append("policy", storage.fields.policy);
      formData.append("signature", storage.fields.signature);
      formData.append("file", file);
      return formData;
    },

    async save() {
      // Verifica se há pelo menos 1 sender selecionado
      if (!this.selectedSenders.length > 0) {
        this.$store.commit("showSnackbar", {
          message: "Selecione pelo menos um sender",
          color: "error",
        });
        return;
      }

      // Verifica se a mensagem tem pelo menos 65 caracteres
      if (!((this.initiative.message || "").length >= 65)) {
        this.$store.commit("showSnackbar", {
          message: "A mensagem deve ter pelo menos 65 caracteres",
          color: "error",
        });
        return;
      }

      // Atualiza as vars da iniciativa antes de enviar (mesmo formato do NewInitiative)
      const message = this.initiative.message || "";
      this.initiative.vars = this.allowedVariables
        .filter((v) => v.selected && message.includes(v.name))
        .sort((a, b) => message.indexOf(a.name) - message.indexOf(b.name))
        .map((v) => v.name.replace(/^\$/, ""));
      
      // Obtém os phone_numbers dos senders selecionados
      const selectedSendersData = this.phone_senders.filter(s => this.selectedSenders.includes(s.id));
      const phoneNumbers = selectedSendersData.map(s => s.phone_number);

      if (!phoneNumbers.length) {
        this.$store.commit("showSnackbar", {
          message: "Nenhum sender válido para clonagem",
          color: "error",
        });
        return;
      }

      this.loadingClone = true;
      this.showResults = false;
      this.cloneResponse = null;

      const promises = [];
      const results = [];
      let templatePayload = null;

      phoneNumbers.forEach((phoneNumber) => {
        const request = initiativesService
          .cloneInitiative({
            initiative: this.initiative,
            phone_numbers: [phoneNumber],
          })
          .then((response) => {
            if (!templatePayload && response && response.template_payload) {
              templatePayload = response.template_payload;
            }

            if (response && Array.isArray(response.results) && response.results.length) {
              response.results.forEach((item) => {
                results.push({
                  ...item,
                  phone_number: item.phone_number || phoneNumber,
                });
              });
              return;
            }

            results.push({
              phone_number: phoneNumber,
              status: "success",
            });
          })
          .catch((error) => {
            const errorMessage = error.response && error.response.data && error.response.data.error
              ? error.response.data.error
              : "Erro ao clonar iniciativa";

            results.push({
              phone_number: phoneNumber,
              status: "error",
              error: errorMessage,
            });
          });

        promises.push(request);
      });

      try {
        await Promise.all(promises);

        const successCount = results.filter(r => r.status === "success").length;
        const failureCount = results.length - successCount;

        this.cloneResponse = {
          message: `Clonagem concluída: ${successCount} sucesso(s), ${failureCount} falha(s).`,
          results,
          template_payload: templatePayload,
        };
        this.showResults = true;
      } finally {
        this.loadingClone = false;
      }
    },

    resultsSuccessCount() {
      if (!this.cloneResponse || !Array.isArray(this.cloneResponse.results)) return 0;
      return this.cloneResponse.results.filter(r => r.status === 'success').length;
    },
    resultsFailureCount() {
      if (!this.cloneResponse || !Array.isArray(this.cloneResponse.results)) return 0;
      return this.cloneResponse.results.filter(r => r.status !== 'success').length;
    },
    resultsByStatus(status) {
      if (!this.cloneResponse || !Array.isArray(this.cloneResponse.results)) return [];
      return this.cloneResponse.results.filter(r => r.status === status);
    },
    exceptionResults() {
      if (!this.cloneResponse || !Array.isArray(this.cloneResponse.results)) return [];
      return this.cloneResponse.results.filter(r => r.status !== 'success');
    },

    limitErrorText(err) {
      if (!err) return "Sem detalhes.";
      return err.length > 1200 ? err.substring(0, 1200) + "\n...[truncado]" : err;
    },
    parseMetaError(err) {
      const technical = this.limitErrorText(err || "");
      const fallback = {
        title: "Falha ao clonar iniciativa",
        message: "Não foi possível processar a solicitação.",
        code: null,
        technical,
      };

      if (!err || typeof err !== "string") {
        return fallback;
      }

      const marker = ' - {"error":';
      const markerIndex = err.indexOf(marker);
      const jsonCandidate = markerIndex >= 0 ? err.slice(markerIndex + 3) : err;

      let parsed;
      try {
        parsed = JSON.parse(jsonCandidate);
      } catch (e) {
        return {
          ...fallback,
          message: technical,
        };
      }

      const apiError = parsed && parsed.error ? parsed.error : parsed;
      const code = apiError && apiError.code ? String(apiError.code) : null;
      const subcode = apiError && apiError.error_subcode ? String(apiError.error_subcode) : null;

      return {
        title: (apiError && apiError.error_user_title) || "Erro de validação do template",
        message: (apiError && (apiError.error_user_msg || apiError.message)) || fallback.message,
        code: code && subcode ? code + "." + subcode : code,
        technical,
      };
    },
    getErrorTitle(err) {
      return this.parseMetaError(err).title;
    },
    getErrorMessage(err) {
      return this.parseMetaError(err).message;
    },
    getErrorCode(err) {
      return this.parseMetaError(err).code;
    },
    getErrorTechnical(err) {
      return this.parseMetaError(err).technical;
    },

    copyTemplatePayload() {
      const payload = this.cloneResponse && this.cloneResponse.template_payload;
      const text = typeof payload === 'object' ? JSON.stringify(payload, null, 2) : (payload || '');
      try {
        if (navigator && navigator.clipboard) {
          navigator.clipboard.writeText(text);
        } else {
          const ta = document.createElement('textarea');
          ta.value = text;
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        this.$store.commit('showSnackbar', { message: 'Payload copiado!', color: 'success' });
      } catch (e) {
        this.$store.commit('showSnackbar', { message: 'Falha ao copiar payload', color: 'error' });
      }
    },
    formatTemplatePayload(payload) {
      if (!payload) return '';
      if (typeof payload === 'object') return JSON.stringify(payload, null, 2);
      try {
        return JSON.stringify(JSON.parse(payload), null, 2);
      } catch (e) {
        return payload;
      }
    },
    closeResults() {
      // fecha e recarrega para listar novas iniciativas
      this.close();
      this.$router.go();
    },
    backToForm() {
      // retorna ao formulário sem fechar
      this.showResults = false;
      this.cloneResponse = null;
    },
    
    removeSender(senderId) {
      this.selectedSenders = this.selectedSenders.filter(id => id !== senderId);
    },
    
    getQualityColor(quality) {
      const colors = {
        'GREEN': 'success',
        'YELLOW': 'warning',
        'RED': 'error',
        'UNKNOWN': 'grey'
      };
      return colors[quality] || 'grey';
    },

    varClick(name) {
      if (!name) return;
      if (!this.initiative.message) this.$set(this.initiative, "message", "");

      const sp = this.initiative.message.endsWith(" ") || this.initiative.message === "" ? "" : " ";
      const value = `${sp}${name}`;

      this.$set(this.initiative, "message", this.initiative.message + value);
      this.updateSelectedVars();
    },

     getAllowedVariables() {
      let vars_ = [];
      this.creditors.forEach((el) => {
        if (el.creditor_id == this.initiative.creditor_id) {
          vars_ = vars_.concat(el.allowed_variables);
        }
      });

      if (!vars_.length) {
        this.allowedVariables = this.variables_array;
      } else {
        if (typeof vars_[0] === "string") {
          vars_ = this.variables_array.filter((item) => vars_.includes(item.name));
        } else {
          this.allowedVariables = vars_;
        }
      }
    },

    updateSelectedVars() {
      if (!this.initiative.message) {
        this.initiative.vars = [];
        this.allowedVariables.forEach((v) => (v.selected = false));
        return;
      }

      const message = this.initiative.message;
      const sortedVars = [...this.allowedVariables].sort((a, b) => b.name.length - a.name.length);

      const foundVars = [];
      sortedVars.forEach((v) => {
        const regex = new RegExp(`\\$${v.name}(?=\\s|$)`, "g");
        if (regex.test(message)) {
          foundVars.push(v.name);
          v.selected = true;
        } else {
          v.selected = false;
        }
      });

      this.initiative.vars = foundVars.sort(
        (a, b) => message.indexOf(`$${a}`) - message.indexOf(`$${b}`)
      );
    },

    copyValue(value, label) {
      try {
        if (navigator && navigator.clipboard) {
          navigator.clipboard.writeText(value || '');
        } else {
          const ta = document.createElement('textarea');
          ta.value = value || '';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        this.$store.commit('showSnackbar', { message: `${label} copiado!`, color: 'green' });
      } catch(e) {
        this.$store.commit('showSnackbar', { message: `Falha ao copiar ${label}`, color: 'error' });
      }
    }

  },
};
</script>

<style lang="scss" scoped>
.initiativeDialog {
  overflow-y: auto !important;
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgb(192, 189, 189);
    border-radius: 10px;
  }
  &::-webkit-scrollbar {
    width: 5px;
    height: 30px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
    border-radius: 20px;
  }
}

h3 {
  margin: 15px 0;
  width: 100%;
  color: #666;
  text-align: left;
}
.clone-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255,255,255,0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.clone-loading {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.clone-results .chips-container {
  max-height: 140px;
  overflow-y: auto;
}
.exception-details pre {
  background: #fafafa;
  padding: 8px 10px;
  border-radius: 4px;
  font-size: 11px;
  line-height: 1.3em;
  max-height: 200px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
}
.error-text {
  position: relative;
  gap: 8px;
}
.exception-header {
  display: flex;
  align-items: center;
}
.debug-payload-pre {
  font-family: Consolas, Monaco, monospace;
  font-size: 11.5px;
  line-height: 1.5;
  color: #a5d6a7;
  padding: 0 16px 14px;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-y: auto;
}
.min-length-warning {
  font-size: 12px;
  background: #fff8e1;
  border: 1px solid #ffe082;
  padding: 6px 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  color: #a06800;
}
.var-container {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;

  .selected {
    background-color: #4caf50;
    color: white;
  }
}

.initiative_selector_sender--status {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: bold;
  margin-left: 8px;
}

.initiative_selector_sender--status.GREEN {
  background-color: #4caf50;
  color: white;
}

.initiative_selector_sender--status.YELLOW {
  background-color: #ff9800;
  color: white;
}

.initiative_selector_sender--status.RED {
  background-color: #f44336;
  color: white;
}

.initiative_selector_sender--status.UNKNOWN {
  background-color: #9e9e9e;
  color: white;
}

.error-friendly {
  flex: 1;
  min-width: 0;
}
.error-text {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.copy-container {
  cursor: pointer;
}

.copy-icon {
  display:none
}

.copy-container:hover .copy-icon {
  display: inline-block;
}

</style>
